import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, options } from '@apexdesigner/schema-tools';

export const processDataType = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Type name (e.g., Customer, Email, string)'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .meta({ format: 'capitalCase' })
      .describe('Human-readable label'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('What the type represents'),

    nativeType: options([
      { value: 'string', name: 'string' },
      { value: 'number', name: 'number' },
      { value: 'boolean', name: 'boolean' },
      { value: 'Date', name: 'Date' },
    ])
      .nullable()
      .optional()
      .excludeWhen('properties?.length > 0')
      .describe(
        'For base/primitive types - the underlying JS type. Undefined for complex types.',
      ),

    values: hasMany('ProcessDataValue', 'dataTypeId'),

    properties: hasMany('ProcessDataProperty', 'dataTypeId'),

    usedByDataProperties: hasMany('ProcessDataProperty', 'typeId'),

    usedByUIProperties: hasMany('ProcessUserInterfaceProperty', 'typeId'),

    usedByServiceProperties: hasMany('ProcessServiceProperty', 'typeId'),

    usedByMessageProperties: hasMany('ProcessMessageProperty', 'typeId'),

    usedByFunctionParameters: hasMany('ProcessFunctionParameter', 'typeId'),

    usedByFunctions: hasMany('ProcessFunction', 'returnTypeId'),
  })
  .describe('A type available in process expressions and data mappings.')
  .as('ProcessDataType');

export { processDataType as processDataTypeSchema };
